import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, OnDestroy, PLATFORM_ID, Inject } from '@angular/core';
import intlTelInput from 'intl-tel-input';
declare var intlTelInputUtils:any;
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'ngx-intl-tel-input',
  templateUrl: './intl-tel-input.component.html',
  styleUrl: './intl-tel-input.component.css'
})
export class IntlTelInputComponent  implements OnInit, AfterViewInit, OnChanges, OnDestroy{
    @ViewChild('telInput', { static: false }) telInput: any;

    @Input() phoneNumber = '';
    @Input() cssClass = 'form-control';
    @Output() phoneNumberChange = new EventEmitter<string>();
    iti:any;
    isInvalid = false;
    selectedCountryCode:any;
    isBrowser: boolean;


    constructor(@Inject(PLATFORM_ID) private platformId: any){
        this.isBrowser = isPlatformBrowser(this.platformId);

    }

    ngOnInit(){
        
    }
    ngAfterViewInit() {
        if (this.isBrowser) {

        if (this.telInput && this.telInput.nativeElement) {
           this.iti = intlTelInput(this.telInput.nativeElement, {
            utilsScript: "../../../assets/scripts/utils.js", 
            nationalMode: false,
            formatOnDisplay: true
          });
          this.selectedCountryCode = this.iti.getSelectedCountryData().dialCode;
        }
      }}
    ngOnChanges(changes: SimpleChanges) {
		
    }
    ngOnDestroy(){
        if (this.iti) {
            this.iti.destroy();
          }
    }

    onFocus = () =>{
        if(this.phoneNumber == undefined || this.phoneNumber == ""){
            var getCode = this.iti.getSelectedCountryData().dialCode;
            this.phoneNumber = "+" + getCode;
        }
    }
    
    onBlur = ()=>{
        this.isInvalid = false;
        if(this.phoneNumber != undefined && this.phoneNumber.trim()){
            if(this.iti.isValidNumber()){
                this.isInvalid = false;
            }
            else{
                this.isInvalid = true;
            }
        }   
    }

    onInputKeyPress = (event: KeyboardEvent) =>{
        const allowedChars = /[0-9\+\-\ ]/;
		const allowedCtrlChars = /[axcv]/; // Allows copy-pasting
		const allowedOtherKeys = [
			'ArrowLeft',
			'ArrowUp',
			'ArrowRight',
			'ArrowDown',
			'Home',
			'End',
			'Insert',
			'Delete',
			'Backspace',
		];

		if (
			!allowedChars.test(event.key) &&
			!(event.ctrlKey && allowedCtrlChars.test(event.key)) &&
			!allowedOtherKeys.includes(event.key)
		) {
			event.preventDefault();
		}
    }

    formatIntlTelInput() {
        if (typeof intlTelInputUtils !== 'undefined') { // utils are lazy loaded, so must check
            var currentText = this.iti.getNumber(intlTelInputUtils.numberFormat.E164);
            if (typeof currentText === 'string') { // sometimes the currentText is an object :)
                this.iti.setNumber(currentText); // will autoformat because of formatOnDisplay=true
            }
        }
    }

    onPhoneNumberChange = () =>{
        this.selectedCountryCode = this.iti.getSelectedCountryData().dialCode;
        // this.formatIntlTelInput();
        this.phoneNumberChange.emit(this.phoneNumber);
    }
}